/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

var ANCHOR_SHARP_REGEXP = /#(\S+)$/;
function getOffsetTop(target, container) {
  var _target$getBoundingCl = target.getBoundingClientRect(),
    top = _target$getBoundingCl.top;
  if (container === window) {
    return top - document.documentElement.clientTop;
  }
  return top - container.getBoundingClientRect().top;
}

export { ANCHOR_SHARP_REGEXP, getOffsetTop };
//# sourceMappingURL=utils.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/anchor/utils.js
// module id = null
// module chunks = 